'use client';

import { useMemo, useState } from 'react';
import Image from 'next/image';
import { buildGoogleFaviconUrl, getFallbackLogoSource, resolveToolLogoSource, canOptimizeUrl } from '@/lib/tool-logo';

export default function SmartLogo({
  logoUrl,
  websiteUrl,
  name,
  logoAlt,
  size = 80,
  className,
}: {
  logoUrl: string | null;
  websiteUrl?: string | null;
  name: string;
  logoAlt?: string | null;
  size?: number;
  className?: string;
}) {
  const googleFavicon = buildGoogleFaviconUrl(websiteUrl ?? null);
  const initialSrc = useMemo(
    () => resolveToolLogoSource(logoUrl, websiteUrl),
    [logoUrl, websiteUrl]
  );
  const [src, setSrc] = useState(initialSrc);

  const isOptimizable = canOptimizeUrl(src);

  return (
    <div className="relative h-full w-full">
      <Image
        src={src}
        alt={logoAlt || `${name} logo`}
        fill
        sizes={`${size}px`}
        className={className || "object-cover"}
        unoptimized={!isOptimizable || src.endsWith('.svg')}
        onError={() => {
          if (src.includes('google.com/s2/favicons')) {
            setSrc(getFallbackLogoSource());
            return;
          }
          if (googleFavicon && src !== googleFavicon) {
            setSrc(googleFavicon);
            return;
          }
          setSrc(getFallbackLogoSource());
        }}
      />
    </div>
  );
}
